/**
 * @author Ariel
 * @date 2020-10-09
 * @description 活动信息弹出
 */
import React from "react";
import moment from "moment";

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = () => {
  return [
    {
      title: '活动名称',
      name: 'name',
      searchItem: {},
      tableItem: {
        width: 200
      },
    },
    {
      title: '活动时间',
      name: 'activityTime',
      tableItem: {
        width: 233,
        render: (text, record) => {
          let {startTime, endTime} = record
          let value = formatterDate(startTime) + ' ~ ' + formatterDate(endTime)
          return <div>{value}</div>
        }
      }
    },
    {
      title: '参加人数',
      name: 'participateNum',
      tableItem: {
        width: 200
      }
    },
  ]
}

const tableApi = (api = {}) => {
  return {
    path: 'activity/list',
    ...api
  }
}

const activity = (self, api) => {
  return {
    type: 'diy',
    initialValue: [],
    columns: columns(),
    cols: {
      xs: 12,
      md: 12,
      xl: 12
    },
    tableApi: tableApi(api)
  }
}

export default activity
